import { useEffect, useState } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as StatementUpload } from "assets/images/icons/project-icons/statement-upload.svg"
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/info-icon-orange.svg"
import iconDownload from "assets/images/icons/project-icons/download-6.svg";
import iconDocCsv from "assets/images/icons/project-icons/icon-csv-2.svg";
import iconTrash from "assets/images/icons/project-icons/trash-2.svg";
import { FileUploader } from 'react-drag-drop-files';
import { toast } from 'react-toastify';
import getFileSize from 'utils/getFileSize';
import Papa from 'papaparse';
import { saveEarnipayTransferBulkCsv, saveEarnipayransferBulkCsvErrors } from 'store/entities/transfers/action';
import { useDispatch } from 'react-redux';


const EarnipayBulkTransfer = ({toggleEarnipayTransferType, toggleTransferDestination, toggleBulkEarnipayReview}) => {
    const dispatch = useDispatch();
    
    const [bulkDocument, setBulkDocument] = useState(true);
    const [csvData, setCsvData] = useState([]);
    const [invalidEntries, setInvalidEntries] = useState([]);
    
    const closeEarnipayTransfersModal = () => {
        toggleEarnipayTransferType();
        toggleTransferDestination();
    }
    
    const handleFileUpload = (file) => {
        setBulkDocument(file);

        Papa.parse(file, {
        header: true,
        complete: (result) => {
            const formattedResult = result?.data?.filter((item) => item?.accountNumber?.length)?.map((entry, index) => {
                if(entry?.accountNumber?.length !== 10 || entry?.amount?.length < 1) {
                    return {
                        ...entry,
                        isInvalid: true,
                        id: index + 1,
                    }
                } else {
                    return {
                        ...entry,
                        id: index + 1,
                    }
                }
            })
            const invalidItems = formattedResult?.filter((record) => record?.isInvalid === true)
            
            setInvalidEntries(invalidItems);
            setCsvData(formattedResult);
        },
        error: (error) => {
            toast.error('Error parsing CSV:', error);
        }
        });
    };
    
    const resetView = () => {
        setBulkDocument(null);
        setCsvData([]);
        setInvalidEntries([]);
    }
    
    const proceedToPreview = () => {
        dispatch(saveEarnipayTransferBulkCsv(csvData));
        dispatch(saveEarnipayransferBulkCsvErrors(invalidEntries))
        
        toggleEarnipayTransferType();
        toggleBulkEarnipayReview();
    }
    
    useEffect(() => resetView(), [])
    
    return (
        <div className='w-full pt-2'>
            <div className="mb-2">Requirements</div>
            <div className="flex items-center w-full bg-[#FEF5E7] text-[#101828] p-3 rounded-lg mb-4">
                <div><IconInfo /></div>
                <div className="text-sm ml-3">
                    File must be CSV and should contain the <span className="font-medium">account name, account number, narration, </span>
                    and <span className="font-medium">amounts</span> you wish to transfer
                </div>
            </div>
            
            <Maybe condition={bulkDocument === null}>
                <div className="w-full flex items-center justify-between mb-3">
                    <div className='text-sm'>Upload CSV file</div>
                    
                    <a href="https://ep-mediafiles.s3.eu-west-1.amazonaws.com/EP_bulk_transfer_csv_1713363811398.csv" target="_blank" rel="noreferrer" download className="w-max flex items-center text-ep-primary-600 text-sm underline cursor-pointer">
                        <img src={iconDownload} alt="download template" className='mr-2' />
                        Download a sample CSV file
                    </a>
                </div>
                <FileUploader handleChange={(e) => handleFileUpload(e)} name="csv" multiple={false} types={["csv"]} onTypeError={(err) => toast.error(err)} onSizeError={(err) => toast.error(err)}>
                    <div>
                        
                        <div className="h-[150px] cursor-pointer border border-dashed border-gray-300 rounded-md w-full flex items-center justify-center flex-col py-4">
                            <StatementUpload />
                            <div className="mt-4 text-ep-gray-500">
                                Drag and drop file or&nbsp;
                                <span className="border-b border-ep-primary-600 pb-px text-ep-primary-600">browse</span>
                            </div>
                        </div>
                    </div>
                </FileUploader>
            </Maybe>
            
            <Maybe condition={bulkDocument !== null}>
                <div className="w-full h-20 px-6 py-7 bg-[#FBFCFF] border border-dashed border-gray-300 rounded-lg flex items-center">
                    <div className="mr-3">
                        <img src={iconDocCsv} alt="file upload" className="object-contain mx-auto" />
                    </div>
                        
                    <div className='w-full'>
                        <div className="space-x-2 items-center">
                            <div className="">
                                <div className="max-w-xs text-sm ellipsis">{bulkDocument?.name}</div>
                                
                                <div className="uppercase my-1 text-sm">{getFileSize(bulkDocument?.size)}</div>
                                
                                <div className="flex items-center">
                                    <div className="w-full h-1 bg-[#10B759] rounded-full"></div>
                                    <div className="text-xs ml-1">100%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div onClick={resetView} className="ml-3 cursor-pointer">
                        <img src={iconTrash} alt="file upload" className="object-contain mx-auto" />
                    </div>
                </div>
            </Maybe>
            
            <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                <button type="button" onClick={closeEarnipayTransfersModal} className="btn btn-transparent-primary mr-3">
                    Cancel
                </button>
                
                <button onClick={proceedToPreview} disabled={bulkDocument === null} type="button" className="btn btn-ep-primary bg-ep-primary-600">
                    Continue
                </button>
            </div>
        </div>
    )
}

export default EarnipayBulkTransfer